<script lang="ts">
  import { onMount } from 'svelte';
  import { Core as EasePick } from '@easepick/core';
  import { LockPlugin } from '@easepick/lock-plugin';
  import Svg from '$src/js/modules/ui/components/Svg.svelte';
  import Input from '$src/js/modules/ui/components/form/Input.svelte';
  import type { InputType } from '$src/types/forms';

  let {
    id,
    name,
    required,
    background,
    attributes,
    placeholder,
    value = $bindable(''),
  }: InputType = $props();

  let picker: InstanceType<typeof EasePick>;

  const clearDateInput = () => {
    picker.clear();
    value = '';
  };

  onMount(() => {
    picker = new EasePick({
      element: `#${id}`,
      css: ['/vendor/datepicker.css'],
      zIndex: 10,
      lang: 'nl-NL',
      grid: 1,
      format: 'DD-MM-YYYY',
      calendars: 1,
      plugins: [LockPlugin],
      LockPlugin: {
        minDate: new Date(),
      },
    });

    if (attributes?.dateObjects) {
      picker.setDate(new Date(attributes.dateObjects as Date));
    }

    picker.on('select', (event: { detail: { date: Date } }) => {
      const { date } = event.detail;

      value = date.toLocaleDateString('nl-NL', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
    });
  });
</script>

<div class="relative">
  <Input
    {id}
    {name}
    {required}
    {background}
    {placeholder}
    {attributes}
    type="text"
    bind:value
  />
  {#if typeof value === 'object' && (value as Date[]).length > 0}
    <button
      class="2xl:fluid-top-[24] absolute top-6 right-2 -translate-y-1/2"
      onclick={clearDateInput}
      ><Svg
        image="cross-normal"
        width={16}
        height={16}
        className="fill-black-1000"
      /></button
    >
  {/if}
</div>
